import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { hydrate } from "@/lib";
import type { Project } from "@/types";
import { fetchProjects } from "./thunk";

export interface ProjectsState {
  projects: Array<Project>;
  status: "idle" | "fetching" | "saving";
  error: string | null;
  currentPage: number;
  finder: {
    name: string;
    state: string;
    platformAnalyticsTagList: Array<string>;
    publishedAt: string;
  };
}

const initialState: ProjectsState = {
  projects: [],
  status: "idle",
  error: "",
  currentPage: 1,
  finder: {
    name: "",
    state: "",
    platformAnalyticsTagList: null,
    publishedAt: ""
  }
};

export const projectsSlice = createSlice({
  name: "projects",
  initialState,
  reducers: {
    updateFinder: (state, action) => {
      state.finder = { ...state.finder, ...action.payload };
    },
    resetFinder: (state) => {
      state.finder = initialState.finder;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(hydrate, (state, action: PayloadAction<string>) => ({
        ...state,
        ...action.payload[projectsSlice.name]
      }))
      .addCase(fetchProjects.pending, (state) => {
        state.status = "fetching";
      })
      .addCase(fetchProjects.fulfilled, (state, action) => {
        state.status = "idle";
        state.projects = action.payload;
      })
      .addCase(fetchProjects.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.error.message;
      });
  }
});

export const { updateFinder, resetFinder, setCurrentPage } =
  projectsSlice.actions;
